'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _actions = require('../../store/actions');

var _style = require('./style.css');

var dataHudlElement = 'vi-controls-restartoverlay';
var iconName = 'replay';
var mapStateToProps = function mapStateToProps() {
  return {
    iconName: iconName,
    dataHudlElement: dataHudlElement,
    className: _style.restartContainer,
    viewBox: '0 0 36 36'
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps, _ref) {
  var playerId = _ref.playerId;

  return {
    onClick: function onClick() {
      dispatch((0, _actions.restartPlayables)(playerId));
    }
  };
};

exports.default = {
  mapStateToProps: mapStateToProps,
  mapDispatchToProps: mapDispatchToProps
};
module.exports = exports['default'];